/**
 * 날짜 문자열을 읽기 쉬운 형식으로 변환합니다.
 * 
 * @param dateString - ISO 형식의 날짜 문자열
 * @returns 포맷된 날짜 문자열
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  // 유효하지 않은 날짜인 경우
  if (isNaN(date.getTime())) return '-';
  
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  
  // 오늘 날짜인 경우 시간 표시
  if (diffDay === 0) {
    if (diffHour === 0) {
      if (diffMin === 0) {
        return '방금 전';
      }
      return `${diffMin}분 전`;
    }
    return `${diffHour}시간 전`;
  }
  
  // 1일 이상 차이나는 경우 날짜 표시
  if (diffDay < 7) {
    return `${diffDay}일 전`;
  }
  
  // 오래된 날짜는 년-월-일 형식으로 표시
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

/**
 * 날짜 문자열을 상세한 형식으로 변환합니다.
 * 
 * @param dateString - ISO 형식의 날짜 문자열
 * @returns 년-월-일 시:분:초 형식의 문자열
 */
export const formatDateDetail = (dateString: string): string => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  // 유효하지 않은 날짜인 경우
  if (isNaN(date.getTime())) return '-';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}; 